'use client';

import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid2';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import Link from 'next/link';

import ErrorImg from '@/assets/images/error.png';
import Logo from '@/assets/images/logo.svg';
import Footer from '@/components/layouts/Footer';

export interface GlobalErrorProps {
	error: Error & { digest?: string };
	reset(): void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function GlobalError({ error, reset }: GlobalErrorProps) {
	return (
		<html>
			<body>
				<Grid height="100%" padding="35px 24px">
					<Link href="/">
						<Logo width={158} height={36} viewBox="0 0 146 24" />
					</Link>
					<Grid
						container
						direction="column"
						justifyContent="center"
						alignItems="center"
						width="100%"
						height="calc(100% - 36px)"
						sx={{
							'& img': {
								width: '100%',
								maxWidth: { xs: 60, md: 90 },
								height: 'auto',
							},
						}}
					>
						<Image src={ErrorImg} alt="error" width={90} />
						<Grid textAlign="center" marginTop={{ xs: 2, md: 4 }}>
							<Typography fontSize={{ xs: 18, md: 28 }} fontWeight={700} lineHeight={1.5}>
								문제가 발생했습니다
							</Typography>
							<Typography fontSize={{ xs: 12, md: 16 }} lineHeight={1.5}>
								잠시 후 다시 시도해주세요
							</Typography>
						</Grid>
						<Stack direction="row" gap={2} marginTop={{ xs: '12px', md: '20px' }}>
							<Button LinkComponent={Link} href="/" variant="outlined">
								<Typography fontWeight={700} fontSize={16} textAlign="center">
									홈으로 가기
								</Typography>
							</Button>
							<Button onClick={reset}>새로고침</Button>
						</Stack>
					</Grid>
				</Grid>
				<Footer />
			</body>
		</html>
	);
}
